import { render, staticRenderFns } from "./qualification-plan-index-preview.vue?vue&type=template&id=a521f8e4&scoped=true"
import script from "./qualification-plan-index-preview.vue?vue&type=script&lang=ts"
export * from "./qualification-plan-index-preview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a521f8e4",
  null
  
)

export default component.exports